import { axios } from 'api'

export enum SortField {
  CREATED_AT = 'createdAt',
  SALES_ORDER_ID = 'netsuiteSalesOrderId'
}

export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface OrderItem {
  itemName: string
  unitPrice: number
  quantity: number
  isAssembled: boolean
  hingeDirection: string | null
}

export interface TransactionDetails {
  transactionId: string
  amount: number
  cardType: string
  cardNumber: string
  billingAddress?: {
    firstName: string
    lastName: string
    address: string
    city: string
    state: string
    zip: string
    country: string
  }
  date?: string
}

export interface WoodlandOrder {
  id: string
  refId: string
  salesOrderId: string
  companyName: string
  status: string
  discountAmount: number
  taxAmount: number
  assemblyFee: number
  shippingFee: number
  convenienceFee: number
  finalAmount: number
  createdAt: string
  pickupTime: string | null
  comment: string | null
  paymentMethod: string
  orderItems: OrderItem[]
  transactionDetails?: TransactionDetails
}

export interface WoodlandOrdersResponse {
  totalOrders: number
  totalPages: number
  currentPage: number
  orders: WoodlandOrder[]
}

export const getWoodlandOrders = async (params: {
  page?: number
  limit?: number
  sortBy?: SortField
  sortDir?: SortDirection
  salesOrderId?: string
  status?: string
}): Promise<WoodlandOrdersResponse> => {
  const response = await axios.get('/orders/all', { params })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error(response.data?.error || 'Failed to fetch woodland orders.')
  }
}
